var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"results-audience"},[(_vm.hasSocial)?_c('SocialAdDemographics',{staticClass:"mb-4"}):_vm._e(),_c('TargetingPerformance')],1)}
var staticRenderFns = []

export { render, staticRenderFns }